
import { Vue, Component } from 'vue-property-decorator';
import { getNoticeList, Notice } from '@/api/notice';

@Component
export default class NoticePage extends Vue {
  private isLoading = false;

  private notices: Notice[] = [];

  private selected: Notice | null = null;

  private detailVisible = false;

  created(): void {
    this.fetchNotices();
  }

  private async fetchNotices(): Promise<void> {
    this.isLoading = true;
    try {
      const res = await getNoticeList();
      this.notices = res.data || [];
    } finally {
      this.isLoading = false;
    }
  }

  private openDetail(item: Notice): void {
    this.selected = item;
    this.detailVisible = true;
  }

  private closeDetail(): void {
    this.detailVisible = false;
  }

  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return dateStr.substring(0, 10);
  }
}
